import { sensorConstants } from "../../constants/client";

const initialState = {};

export default function sensor(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case sensorConstants.LISTING_REQUEST:
      currentstate = {
        //paginationOptions: null,
        list: null,
        error: null,
        update_required: null,
        details: null,
        loading: true
      };
      break;
    case sensorConstants.LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        loading: false
      };
      break;
    case sensorConstants.LISTING_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;
      
    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
